/* @flow strict */

import * as React from 'react';

type PropsType = {
  className?: string,
  headerClassName?: string,
  title: string | React.Node,
  children: React.Node
};

const Panel = ({
  className,
  headerClassName,
  title,
  children
}: PropsType): React.Element<typeof React.Element> => {
  return (
    <div className={`panel panel-default ${className}`}>
      <div className={`panel-heading ${headerClassName}`}>
        <h3 className="panel-title">
          {title}
        </h3>
      </div>
      <div className="panel-body">
        {children}
      </div>
    </div>
  );
};

export default Panel;
